// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"Avatar_avatarContainer__2koem","tooltip":"Avatar_tooltip__2tDon","avatar":"Avatar_avatar__33rUO"};